// import debug from 'debug-es';

export default (...args: any[]) => {}; // debug('robotsnacks:composer');
